
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { TabPanel, Tabs } from "react-tabs";
import NonLoginHeader from "../../components/header/NonLoginHeader";
import MobileHeader from "../../components/header/MobileHeader";
import registerGraphic from '../../assets/images/login/register1-graphic (1).png'
import toast from "react-hot-toast";
import axios, { PublicKey } from "../../API/axios";

function ForgotPassword() {
  const [selectedDropdownOption, setSelectedDropdownOption] = useState("Candidate"); // Controls dropdown selection
  const [displays, setDisplays] = useState(false)


  const handleDropdownChange = (event) => {
    setSelectedDropdownOption(event.target.value);
  };


  const [isShowMobile, setShowMobile] = useState(false);
  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };



  const [email, setEmail] = useState('')
  const ResetPassword = async (e, responseData) => {
    e.preventDefault()
    try {
      setDisplays(true)
      if (email !== '') {
        const res = await axios.post(`/Auth/ResetPasswordByEmail?EmailAddress=${email}&UserType=${selectedDropdownOption}`, {},
          {
            headers: {
              PublicKey,
            },
          }
        );
        toast.success(res.data.message)
        setEmail('')
        setDisplays(false)
      } else {
        toast.error("please enter required fields!")
      }

    } catch (error) {
      if (error.response && error.response.status === 404) {
        toast.warning(error.response.data.message)
      } else {
        toast.error(error.response.data.message)
      }
    }
  };


  return (
    <>
      <MobileHeader handleMobile={handleMobile} />
      <NonLoginHeader clname="actPage9" handleMobile={handleMobile} />
      <div className="pt-70">
        <div className="container">
          <div className="row">
            <div className="col-md-6 registerGraphics">
              <img src={registerGraphic} />
            </div>
            <div className="col-md-6">
              <Tabs className="wd-form-login tf-tab">
                <h4 className="mt-3">Forgot Password</h4>
                <div className="content-tab">
                  <TabPanel className="inner animation-tab">
                    <form action="/">
                      <div className="ip">

                        <p>Forgot your password? Enter your email and we will send a link to help you reset it.</p>
                      </div>
                      <ul className=" Forgot-menu-tab">
                        <li className="me-4">{selectedDropdownOption}</li>
                        <li>
                          <div className="post-form-group">
                            <select
                              className="ct-tab-dropdown"
                              value={selectedDropdownOption}
                              onChange={handleDropdownChange}
                            >
                              <option value="Candidate">Candidate</option>
                              <option value="Institution">Institution</option>
                              <option value="Company">Company</option>
                              <option value="Recruiter">Recruiter</option>
                            </select>
                          </div>
                        </li>
                      </ul>
                      <div className="ip">
                        <label>Email ID</label>
                        <input
                          type="email"
                          // defaultValue="Tony Nguyen"
                          placeholder="Email"
                          onChange={(e) => { setEmail(e.target.value) }}
                          value={email}
                          id="email"
                          name="email"
                          invalid={displays && email === ''}
                        />
                        {displays && !email ? <span className='error_msg_lbl text-red'>Enter Email Address </span> : null}

                      </div>
                      <div className="group-ant-choice st">
                      </div>
                      <button type="submit" onClick={(e) => ResetPassword(e)}>
                        <Link >
                          Send</Link>
                      </button>
                    </form>
                  </TabPanel>
                </div>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ForgotPassword;
